var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions.define_lightning_manager = function () {
    OCS.Viewer.Classes.LightningManager = new Class({
        Extends: OCS.Viewer.Classes.SingletonManager,
        class_name: "LightningManager",
        manager_name: 'LightningManager',
        current_lightning: null,
        dataworker_activation: null,
        lightningworker_activation: null,
        date_request_active: false,
        last_update_recieved: null,
        get_initial_data: true,
        dataset_obj: null,
        lightning_update_call: null,
        feature_keys: {},
        repeats: 0,
        options: {
            actively_retrieve_data: true,
            dataset: 'edu.ou.ocs.lightning',
            debug: false,
            lightning_storage_key_prefix: "fd", // Flash Data
            states: OCS.Viewer.Config.lightning_info.default_states
        },
        init: function (op) {
            OCS.Viewer.Functions.init_utilities();
            this.lightning_update_call = OCS.Viewer.Functions.get_utilities().create_debounced_method(this.lightning_update.bind(this), 10000);
            if (OCS.Viewer.Functions.use_workers()) {
                this.dataworker_activation = setTimeout(this.start_data_worker.bind(this), OCS.Viewer.Config.dataworker_start_time);
                OCS.Viewer.Functions.get_event_manager().subscribe({event_name: OCS.Viewer.Config.events.DATAWORKER_ONLINE, callback: this.on_dataworker_online.bind(this), fire_immediately: true, once: true});
            }
            var dateObj = OCS.Functions.get_OCSDateTime();
            if (dateObj.options.anchor) {
                OCS.Viewer.Config.lightningworker.class_options.datetime_anchor = true;
                OCS.Viewer.Config.lightningworker.class_options.datetime_settings = dateObj.get_current_time_settings();
            }
            this.lightningworker_activation = setTimeout(OCS.Viewer.Functions.start_lightning_worker, OCS.Viewer.Config.dataworker_start_time);
            this.initialize_events();
        },
        initialize_events: function () {
            this.addEvent('refresh', this.on_refresh.bind(this));

        },
        /*
         * 
         * Event fires
         * 
         */
        lightning_update: function () {
            // Now that we have added data, lets remove old features
            var dateObj = OCS.Functions.get_OCSDateTime();
            var earliest_epoch_ts = dateObj.get_start_epoch_time();
            var keys = Object.keys(this.feature_keys);
            var split_string = [];
            keys.each(function (feature_key) {
                split_string = feature_key.split("|");
                if (split_string[1] < earliest_epoch_ts) {
                    delete this.feature_keys[feature_key];
                }
            }.bind(this));
            this.last_update_recieved = dateObj.get_server_epoch_time();
            this.fireEvent('lightning_update');
        },
        /*
         * 
         * Event Listeners
         * 
         */
        on_dataworker_message: function (event) {
            var data_obj;
            if (event.cmd) {
                switch (event.cmd) {
                    case 'data':
                        var ds = OCS.Functions.get_dataset_from_node(event.options.entry.json.dataset);
                        if (ds && ds.getOption('dataset') === this.options.dataset) {
                            data_obj = OCS.Functions.define_data_obj(event.options);
                            var data_json = data_obj.json();
                            if (data_json.data && data_json.data.features && data_json.data.features.length) {
                                this.process_data(data_obj);
                            }

                            // Is it dates?
                            if (data_json.dates && data_json.dates.length) {
                                this.process_dates(data_json);
                            }

                        }
                        break;
                    case 'current_lightning':
                        this.current_lightning = OCS.Functions.define_data_obj(event.options);
                        this.lightning_update_call();
                        break;
                    case 'console_debug':
                        console.debug(event.options.originator+":", event.options.msg);
                        break;
                }
            }
        },
        on_dataworker_online: function () {
            this.subscribe();
            this.init_data();
        },
        on_lightningworker_online: function () {

        },
        on_refresh: function () {
            this.get_initial_data = true;
            this.init_data();
        },
        /*
         * 
         * Actions
         * 
         */

        init_data: function () {
            if (this.get_initial_data && !this.date_request_active) {
                var dateObj = OCS.Functions.get_OCSDateTime();
                var earliest_epoch_ts = dateObj.get_start_epoch_time();
                var latest_epoch_ts = dateObj.get_end_epoch_time();
                var dataset = this.get_dataset_obj();
                var stale = dataset.getOption('stale_threshold');
                this.send_data_worker_message({'cmd': 'get_dates', 'options': {dataset: this.options.dataset, url: dataset.get_query_url({start: dateObj.get_utc_long_string(earliest_epoch_ts - (stale / 2)), end: dateObj.get_utc_long_string(latest_epoch_ts)})}});
                this.date_request_active = true;
            }
        },
        process_data: function (data_obj) {
            if (data_obj) {
                var data_json = data_obj.json();
                if (data_json.data) {
                    this.parse_geojson_lightning(data_json.data);
                }
                if (data_json.data_4326) {
                    this.parse_geojson_lightning(data_json.data_4326);
                }

                // send to worker
                this.send_lw_msg({cmd: 'process_data', options: data_obj.stringify()});



                //this.lightning_update_call();

            }



        },
        process_dates: function (dates) {
            if (dates.dates) {
                var dateObj = OCS.Functions.get_OCSDateTime();
                var dates_array = dates.dates.reverse();
                var epoch;
                var dataset = this.get_dataset_obj();
                var cookie = OCS.Viewer.Functions.get_session_cookie();
                Object.each(dates_array, function (in_date, index) {
                    epoch = dateObj.date_long_string_to_epoch(in_date);
                    this.send_data_worker_message({'cmd': 'get_data', 'options': {cookie: cookie, timestamp_epoch: epoch, dataset: this.options.dataset, url: dataset.get_url({date: dateObj.get_utc_long_string(epoch)})}});
                }.bind(this));
            }
        },
        parse_geojson_lightning: function (ldata) {
            var flash;
            if (ldata.crs.properties.name.contains('EPSG::4326')) {
                for (var j = 0; j < ldata.features.length; j++) {
                    flash = ldata.features[j];
                    flash.geometry.coordinates = ol.proj.fromLonLat(flash.geometry.coordinates, OCS.Viewer.Config.default_projection);
                }
            }
        },
        send_lw_msg: function (msg) {
            var dw = OCS.Viewer.Functions.get_lightning_worker();
            if (dw) {
                if (OCS.Viewer.Functions.use_workers()) {
                    dw.add_to_msg_queue(msg);
                } else {
                    dw.process_command(msg);
                }
            }
        },
        subscribe: function () {
            var node_path = this.get_dataset_obj().get_node_path();
            this.options.states.each(function (state) {
                this.send_data_worker_message({'cmd': 'subscribe_init', 'options': {
                        dataset: this.options.dataset,
                        node_path: node_path,
                        data_type: 'GeoJsonData',
                        state: state,
                        variables: []
                    }});
            }.bind(this));

        },
        unsubscribe: function () {
            var node_path = this.get_dataset_obj().get_node_path();
            this.options.states.each(function (state) {
                this.send_data_worker_message({'cmd': 'subscribe_terminate', 'options': {
                        dataset: this.options.dataset,
                        node_path: node_path,
                        data_type: 'GeoJsonData',
                        state: state,
                        variables: []
                    }});
            }.bind(this));
        },

        get_lightning: function (map_datetime) {
            return this.current_lightning;
        },
        /**
         * Returns an array of features based on the available lightning at a given map time. This can be further filtered by providing a coordinate and reference distance
         * 
         * @param {OCS.Viewer.Classes.MapDateTime} map_datetime - A map date time object
         * @param {Array} [ref_coord] - [lon, lat]
         * @param {Number} [ref_dist] - Distance in miles from the reference coordinate
         * @returns {Array} An array of ol objects.
         */
        get_lightning_features: function (map_datetime, ref_coord, ref_dist) {
            var features = [];
            var start = map_datetime.get_frame_from_timestamp(map_datetime.get_start_epoch_time());
            var end = map_datetime.get_frame_from_timestamp(map_datetime.get_end_epoch_time());
            var key, rangeMi, i, feature, flash, datetime, flash_coords;
            if (this.current_lightning && this.current_lightning.data) {
                var data = this.current_lightning.data().features;
                var feature_keys = {};
                for (i = 0; i < data.length; i++) {
                    flash = data[i];
                    datetime = flash.properties.timestamp;
                    flash_coords = flash.geometry.coordinates;
                    if (datetime > (end + map_datetime.options.time_increment) || datetime < (start - map_datetime.options.time_increment)) {
                        continue;
                    }
                    if (ref_coord && ref_dist) {
                        rangeMi = this.rangeBetweenPoints(ref_coord, ol.proj.toLonLat(flash_coords)) / 1000 * 0.621371;
                    }
                    if (!ref_coord || rangeMi < ref_dist) {
                        key = OCS.Worker.Functions.get_lightning_key(flash, datetime);
                        if (!feature_keys[key]) {
                            if (!this.feature_keys[key]) {
                                feature = new ol.Feature({
                                    geometry: new ol.geom[flash.geometry.type](flash_coords)
                                });
                                feature.setProperties({t: datetime, a: flash.properties.amp, c: flash.properties.iscg});
                                this.feature_keys[key] = feature;
                            }
                            feature_keys[key] = true;
                            features.push(this.feature_keys[key]);
                        }
                    }
                }
            }
            return features;
        },

        rangeBetweenPoints: function (inPoint1, inPoint2) {
            var wgs84Sphere = new ol.Sphere(6378137);
            return wgs84Sphere.haversineDistance(inPoint1, inPoint2);
        },
        get_dataset_obj: function () {
            if (!this.dataset_obj) {
                var dataset = this.options.dataset;
                /* istanbul ignore else */
                if (dataset && OCS.Datasets[dataset]) {
                    this.dataset_obj = OCS.Datasets[dataset];
                } else {
                    this.dataset_obj = new OCS.Classes.Dataset();
                }
            }
            return this.dataset_obj;
        },
        destroy: function () {
            if (this.options.debug) {
                console.debug('Lightning Manager: Destroying!');
            }
            this.unsubscribe();
            if (this.dataworker_activation) {
                clearTimeout(this.dataworker_activation);
                this.dataworker_activation = null;
            }
            if (this.lightningworker_activation) {
                clearTimeout(this.lightningworker_activation);
                this.lightningworker_activation = null;
            }
            this.data = {};
            this.destroy_manager();
        }
    });
    OCS.Viewer.Classes.LightningManager.implement(OCS.Viewer.Interfaces.DataAccessor);
    OCS.Viewer.Classes.LightningManager.implement(OCS.Viewer.Interfaces.DataWorker);
    OCS.Viewer.Functions.get_lightning_manager = function (ops) {
        if (!OCS.Viewer.Live.LightningManager) {
            new OCS.Viewer.Classes.LightningManager(ops);
        }
        return OCS.Viewer.Live.LightningManager;
    };
    OCS.Viewer.Functions.get_lightning_worker = function () {
        if (!OCS.Viewer.Live.LightningWorker) {
            OCS.Viewer.Functions.start_lightning_worker();
        }
        return OCS.Viewer.Live.LightningWorker;
    };
    OCS.Viewer.Functions.start_lightning_worker = function () {
        var lm = OCS.Viewer.Functions.get_lightning_manager();
        if (lm.lightningworker_activation) {
            clearTimeout(lm.lightningworker_activation);
            lm.lightningworker_activation = null;
        }
        try {
            if (OCS.Viewer.Functions.use_workers() && OCS.Viewer.Functions.start_lightning_worker_with_worker) {
                return OCS.Viewer.Functions.start_lightning_worker_with_worker();
            } else {
                return OCS.Viewer.Functions.start_lightning_worker_without_worker();
            }
        } catch (e) {
            console.warn("Tried to start the lightning worker after already starting it.");
        }
    };
    OCS.Viewer.Functions.start_lightning_worker_with_worker = function () {
        var wm = OCS.Functions.get_worker_manager();
        var worker = wm.register_worker({
            'msg_queue': [{
                'cmd': 'init',
                'options': OCS.Viewer.Config.lightningworker
            }],
            'path': OCS.Package.root + OCS.Viewer.Functions.get_lightningworker_path()
        });
        if (worker && worker.class_type === "WorkerHandler") {
            var lm = OCS.Viewer.Functions.get_lightning_manager();
            OCS.Viewer.Live.LightningWorker = worker;
            OCS.Viewer.Live.LightningWorker.onmessage = lm.on_dataworker_message.bind(lm);
        }
        delete OCS.Viewer.Functions.start_lightning_worker_with_worker;
    };
    OCS.Viewer.Functions.start_lightning_worker_without_worker = function () {
        if (!OCS.Viewer.Live.LightningWorker) {
            //OCS.Worker.Classes.DataWorker.implement(OCS.Worker.Interfaces.DataWorkerWithoutW);
            var lm = OCS.Viewer.Functions.get_lightning_manager();
            OCS.Viewer.Live.LightningWorker = new OCS.Worker.Classes.LightningWorker(OCS.Viewer.Config.lightningworker.class_options);
            OCS.Viewer.Live.LightningWorker.addEvent('worker_message', lm.on_dataworker_message.bind(lm));
            delete OCS.Viewer.Functions.start_lightning_worker_without_worker;
            return true;
        }
    };
};
OCS.Viewer.Functions.define_lightning_manager();
